/**
 * @param {String | number} x
 * @return {number}
 */
export const safeParseInt = (x) => {
  if (typeof x === 'number') {
    return x
  } else {
    try {
      return parseInt(x)
    } catch (_e) {
      try {
        return parseInt(x.replace(/[^0-9]/g, ''))
      } catch (_e2) {
        return 0
      }
    }
  }
}

/**
 * @param {String | Null} s
 * @return {number | Null}
 */
export const parseIntOrNull = (s) => {
  if (!s) {
    return null
  } else {
    try {
      const result = parseInt(s)
      if (`${result}` === s) {
        return result
      } else {
        return null
      }
    } catch (_e) {
      return null
    }
  }
}
